import { mapEventToElalDataLayer } from '../providers/gtm/elal-events';
import { EVENTS } from '../events/user';
import { getUserObject } from './userService';
import GlobalProperties from '../global_properties_attached_to_events';
import { LOYALTY_POINTS_STATUS } from '../../../general/constants';

export const getAnalyticsPointsBalance = (points) => points?.status !== LOYALTY_POINTS_STATUS.INITIALIZED
    && Number.isFinite(points?.balance) ? points.balance : undefined;

export const getUserDataSnapshotKey = (profile, pointsBalance) => JSON.stringify(
    mapEventToElalDataLayer(EVENTS.USER_DATA_UPDATED, {
        ...getUserObject(profile),
        logged_in: !!profile?.isLoggedIn,
        ...(Number.isFinite(pointsBalance) && { points_balance: pointsBalance }),
        ...GlobalProperties.items()
    })
);

export const updateLoyaltyGlobalProperties = (points) => {
    const tier = points?.customer_tier || points?.tier;
    const member = points?.member_number;
    if (tier) {
        GlobalProperties.setItem('customer_tier', tier);
    }
    if (member) {
        GlobalProperties.setItem('member_id', member);
        GlobalProperties.setItem('matmid_id', member);
    }
};
